import { apiFetch } from '../../../shared/api/apiFetch'

/**
 * Which pins, lines and collections the signed-in hunter has switched off on
 * their own map — the two lists the app keeps on the user document, so a switch
 * flipped in the browser holds on the phone and the other way round.
 *
 * `hiddenPinIds` carries line ids as well as pin ids: the app keeps both kinds
 * in the one list, and the two id spaces do not collide.
 */
export interface MyPinVisibilityDto {
  hiddenPinIds: string[]
  hiddenCollectionIds: string[]
}

/**
 * A change, never a whole list: the app writes the same lists, and a browser
 * writing back a list it read earlier would undo every switch flipped on the
 * phone since.
 */
export interface PinVisibilityChange {
  hidePinIds: string[]
  showPinIds: string[]
  hideCollectionIds: string[]
  showCollectionIds: string[]
}

export async function getMyPinVisibility(token: string): Promise<MyPinVisibilityDto> {
  return apiFetch<MyPinVisibilityDto>('/clubhouse/me/map-pin-visibility', { token })
}

export async function updateMyPinVisibility(
  change: PinVisibilityChange,
  token: string,
): Promise<MyPinVisibilityDto> {
  return apiFetch<MyPinVisibilityDto>('/clubhouse/me/map-pin-visibility', {
    method: 'PATCH',
    body: JSON.stringify(change),
    token,
  })
}
